import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  modelForEdit: {
    id: undefined,
    name: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
  stateData: {},
  selectedTab: 0,
  modelId: undefined,
  showModelPopover: false,
  showDeleteDialog: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const modelSlice = createSlice({
  name: "models",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // category loader
    modelListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    modelList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadModelForEdit: (state, action) => {
      state.modelForEdit = action.payload;
    },
    loadModelForEdit: (state, action) => {
      const payload = action.payload;

      state.modelForEdit.name = payload.name;
      state.modelForEdit.id = payload.id;
      state.modelForEdit.makeId = payload.make;
      state.modelForEdit.categoryId = payload.make?.category;
      state.modelForEdit.assetClassId =
        payload.make?.category?.assetCategoryClass;
    },
    loadModelMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    loadState: (state, action) => {
      state.stateData = action.payload;
    },
    setTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setModelIdData: (state, action) => {
      state.modelId = action.payload;
      state.showModelPopover = !state.showModelPopover;
    },
    setDeleteDialogData: (state, action) => {
      state.showDeleteDialog = !state.showDeleteDialog;
      state.modelId = action.payload;
    },
  },
});
